/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMagazine32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M27 3.904a56.549 56.549 0 00-14.833-1.357 34.563 34.563 0 018.673 2.685l1.944.895.436.201v23.195a1.243 1.243 0 01-1.782 1.121h-.001l-.074-.036-.004-.002-.004-.002-.226-.109a33.07 33.07 0 00-14.333-3.267H3V2.058h.009l-.003-.02 3.45-.48a58.047 58.047 0 0121.468 1.02l.576.138v23.6H27V3.905zm-5.28 25.211V7.288l-1.508-.694c-4.34-2-9.061-3.036-13.84-3.036H4.5v22.17h2.296a34.571 34.571 0 0114.924 3.387zM12.5 8.058h.75v-1.5h-3v1.5H11v1.5H8.5v-1.5h.75v-1.5h-3v1.5H7v4.5h-.75v1.5h3v-1.5H8.5v-1.5H11v1.5h-.75v1.5h3v-1.5h-.75v-4.5zm3.75 11h-10v-1.5h10v1.5zm-10 3h5.5v-1.5h-5.5v1.5zM21.591 5.006c1.294.481 2.282.845 2.834 1.046v22.399h1.5V5.003l-.494-.18S24.154 4.36 22.115 3.6a.505.505 0 00-.65.297l-.17.459a.505.505 0 00.296.65z'
      />
    </svg>
  );
}

export default SvgMagazine32;
